import CollapseItemsGroup from './CollapseItemsGroup';

export default CollapseItemsGroup;
